import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiGet } from "../../../services/apiServices";
import { endPoints } from "../../../configs/apiUrls";

interface User {
    _id: string;
    name: string;
    email: string;
    userType?: string;
    state?: string;
    city?: string;
    area?: string;
    // Add other fields as necessary
}

interface UserListResponse {
    filterData: {
        userType: string;
        state: string;
        city: string;
        area: string;
        search: string;
        sortBy: any,
        sortOrder: any,
        totalCount: number,
        page: number,
        limit: number
    };
    success: boolean;
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    data: User[];
}

interface FetchUserListParams {
    page?: number;
    limit?: number;
    userType?: string;
    state?: string;
    city?: string;
    area?: string;
    search?: string;
    sortBy: string | null
    sortOrder: "asc" | "desc" | null
}

export const fetchUserList = createAsyncThunk<UserListResponse, FetchUserListParams>(
    "users/fetchUserList",
    async (
        {
            page = 1,
            limit = 10,
            userType = "",
            state = "",
            city = "",
            area = "",
            search = "",
            sortBy = null,
            sortOrder = null
        },
        thunkAPI
    ) => {
        try {
            const params = {
                page,
                limit,
                userType: userType || undefined,
                state: state || undefined,
                city: city || undefined,
                area: area || undefined,
                search: search || undefined,
                sortBy: sortBy || null,
                sortOrder: sortOrder || null
            };
            const response = await apiGet(endPoints.GET_USER_LIST, params);
            return {
                data: response.data?.length ? response.data : [],
                filterData: {
                    userType,
                    state,
                    city,
                    area,
                    search,
                    page: response.page,
                    limit: response.limit,
                    totalCount: response.total,
                    sortBy,
                    sortOrder,
                },
                success: response.success,
                page: response.page,
                limit: response.limit,
                total: response.total,
                totalPages: response.totalPages,
            };
        } catch (error) {
            return thunkAPI.rejectWithValue("Failed to fetch user list");
        }
    }
);
